<!--充值记录列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">发票受理</span>
      </div>
    </div>
    <div class="tips" style="margin-bottom: 20px">
      <Icon
        type="md-alert"
        size="20"
        color="#2d8cf0"
        style="margin-right: 10px"
      />
      <div>
        说明：消费者的开票申请将呈现在此页面，请合作伙伴收到申请后尽快处理（只针对游客和普通会员的消费发票申请）
      </div>
    </div>

    <div class="content-header">
      <div class="left">
        <Select
          v-model="page.type"
          @on-change="typeChange"
          style="width: 80px; text-align: center"
        >
          <Option :value="-1">全部</Option>
          <Option :value="0">个人</Option>
          <Option :value="1">单位</Option>
        </Select>
        <DatePicker
          v-model="page.start"
          type="date"
          placeholder="开始日期"
          style="width: 130px; margin: 0 5px"
          :editable="false"
        ></DatePicker>
        <span>至</span>
        <DatePicker
          v-model="page.end"
          type="date"
          placeholder="结束日期"
          style="width: 130px; margin: 0 5px"
          :editable="false"
        ></DatePicker>
        <Button type="primary" style="margin: 0 0 0 5px" @click="getData"
          >查询</Button
        >

        <Button style="margin: 0 0 0 5px" @click="reset">重置</Button>
      </div>
      <div class="right">
        <Poptip title="导出Excel" placement="left" trigger="hover">
          <Button style="margin: 0 5px 1px 0">导出Excel</Button>
          <div slot="content">
            <Button
              type="primary"
              style="margin-right: 5px"
              @click="exportData(0)"
              >导出当前页</Button
            >
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
        <Input
          search
          enter-button="搜索"
          placeholder="全局搜索"
          @on-search="globalSearch"
          style="width: 150px; margin-left: 5px"
        />
      </div>
    </div>
    <div>
      <Table :columns="columns" :data="data" :loading="tableLoad" />
    </div>
    <div class="t-right">
      <Page
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
        :total="total"
        show-elevator
        show-sizer
        show-total
      />
    </div>

    <Modal v-model="visible" title="上传电子发票" width="500">
      <Form ref="formInLayer" :model="fromData" :label-width="100" inline>
        <div>
          <Upload
            multiple
            type="drag"
            :action="`https:${config.imgSrc}/print/invoice/upload`"
            :data="{ id: fromData.id }"
            accept="application/pdf"
            :show-upload-list="false"
            :format="['pdf']"
            name="file"
            :on-format-error="FormatError"
            :on-success="UploadSuccess"
          >
            <div style="padding: 20px 0">
              <Icon
                type="ios-cloud-upload"
                size="52"
                style="color: #3399ff"
              ></Icon>
              <p>单击或拖动文件到此处上传</p>
            </div>
          </Upload>
        </div>
      </Form>
      <div slot="footer">
        <Button size="large" @click="visible = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import excel from '@/libs/excel'
import config from '@/config'
import { verifyDate } from '@/libs/util'

export default {
  data () {
    return {
      config,
      page: {
        p: 0,
        l: 10,
        type: -1,
        start: this.$moment(new Date(), 'YYYY-MM-DD'),
        end: this.$moment(new Date(), 'YYYY-MM-DD'),
        key: 'l.id',
        order: 'desc',
        search: ''
      },
      columns: [
        {
          title: '编号',
          key: 'id',
          width: 100
        },
        { title: '发票开具方', width: 120, key: 'agent_name' },
        {
          title: '用户编号',
          key: 'user_id',
          width: 120
        },
        { title: '用户名称', key: 'user_name', width: 120 },
        { title: '发票备注', key: 'log', width: 120, tooltip: true },
        { title: '用户账号', key: 'tel', width: 180 },
        {
          title: '类型',
          key: 'type',
          render: (h, data) => {
            switch (data.row.type) {
              case 0:
                return h('span', {}, '个人')
                break
              case 1:
                return h('span', {}, '单位 ')
                break
            }
          },
          width: 100
        },
        { title: '发票抬头', key: 'name', width: 200 },
        { title: '纳税人识别号', key: 'code', width: 300 },
        { title: '发票金额', key: 'money', width: 120 },
        {
          title: '申请时间',
          key: 'create_time',
          render: (h, data) => {
            return h('span', this.$moment(new Date(data.row.create_time)))
          },
          width: 200
        },
        {
          title: '状态',
          key: 'status',
          render: (h, data) => {
            switch (data.row.status) {
              case 0:
                return h('span', {}, '开票中')
                break
              case 1:
                return h('span', {}, '已开票')
                break
            }
          },
          width: 150
        },
        {
          title: '开票时间',
          key: 'invoice_time',
          render: (h, data) => {
            if (!data.row.invoice_time) return ''
            return h('span', this.$moment(new Date(data.row.invoice_time)))
          },
          width: 200
        },
        {
          title: '邮箱地址',
          key: 'email',
          width: 200
        },
        {
          title: '设备',
          key: 'sn',
          width: 300,
          render: (h, data) => {
            let sn = []
            let params = data.row.machine_json
              ? JSON.parse(data.row.machine_json)
              : []
            params.map((item) => {
              sn.push(item.sn)
            })
            return h('span', sn.join(','))
          }
        },
        {
          title: '操作',
          key: 'operate',
          export_ignore: true,
          render: (h, data) => {
            let temp = [],
              flag = false
            // 合作伙伴
            if (this.agent.tp === 1 && data.row.user_id) {
              flag = true
              // 代理商
            } else if (
              this.agent.tp === 0 &&
              (!data.row.user_id || data.row.agent_id === this.agent.id)
            ) {
              flag = true
            }
            if (flag) {
              return h('div', {}, [
                h(
                  'Button',
                  {
                    props: {
                      size: 'small',
                      type: 'success'
                    },
                    on: {
                      click: () => {
                        if (data.row.status) {
                          this.send(JSON.parse(JSON.stringify(data.row)))
                        } else {
                          this.openModal(JSON.parse(JSON.stringify(data.row)))
                        }
                      }
                    }
                  },
                  !data.row.status ? '开票' : '再次发送'
                )
              ])
            }
          },
          fixed: 'right',
          width: 100
        }
      ],
      data: [],
      total: 0,
      tableLoad: false,
      fromData: {
        id: 0,
        file: false
      },
      visible: false,
      modalLoading: false
    }
  },
  methods: {
    typeChange () {
      this.getData()
    },
    globalSearch (value) {
      this.page.search = value
      this.getData()
    },
    editDate () {
      this.getData()
    },
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    reset () {
      this.page.p = 0
      this.page.l = 10
      this.page.key = 'l.id'
      this.page.order = 'desc'
      this.page.type = -1
      this.setDate()
      this.getData()
    },
    setDate () {
      let myDate = new Date()
      myDate.setFullYear(myDate.getFullYear() - 1)
      this.page.start = this.$moment(myDate, 'YYYY-MM-DD')
      this.page.end = this.$moment(new Date(), 'YYYY-MM-DD')
    },
    getData () {
      if (verifyDate(this.page.start, this.page.end)) {
        this.$Message.error('开始时间不能大于结束时间')
        return
      }
      this.tableLoad = true
      this.InvoiceList(this.page).then((res) => {
        this.data = res.data
        this.total = res.total
        this.tableLoad = false
      })
    },
    exportData (is_all) {
      let params = {
        title: [],
        key: [],
        autoWidth: true,
        filename: '发票受理'
      }
      this.columns.map((item) => {
        if (item.export_ignore) {
          return
        }
        params.title.push(item.title)
        params.key.push(item.key)
      })
      if (is_all) {
        this.page.p = 0
        this.page.l = this.total
        this.InvoiceList(this.page).then((res) => {
          if (res.data.length) {
            res.data.map((item) => {
              item.type = item.type ? '单位' : '个人'
              item.status = item.status ? '已开票' : '开票中'
              item.create_time = this.$moment(new Date(item.create_time))
              item.invoice_time = item.invoice_time
                ? this.$moment(new Date(item.invoice_time))
                : '-'
            })
            params.data = res.data
            excel.export_array_to_excel(params)
          } else {
            this.$Message.error('无数据,无法导出')
          }
        })
      } else {
        if (this.data.length) {
          params.data = JSON.parse(JSON.stringify(this.data))
          params.data.map((item) => {
            item.type = item.type ? '单位' : '个人'
            item.status = item.status ? '已开票' : '未开票'
            item.create_time = this.$moment(new Date(item.create_time))
            item.invoice_time = this.$moment(new Date(item.invoice_time))
          })
          excel.export_array_to_excel(params)
        } else {
          this.$Message.error('无数据,无法导出')
        }
      }
    },
    openModal (data) {
      this.fromData.id = data.id
      this.$refs.formInLayer.resetFields()
      this.visible = true
    },

    FormatError () {
      this.$Message.error('文件格式错误')
    },
    UploadSuccess () {
      this.$Message.success('上传发票成功，邮件已发送')
      this.visible = false
      this.getData()
    },
    send (data) {
      this.SendEmail({ id: data.id }).then((res) => {
        if (res.code != 1) {
          this.$Message.error(res.msg)
          return
        }
        this.$Message.success(res.msg)
      })
    },
    ...mapActions(['InvoiceList', 'UploadInvoice', 'SendEmail'])
  },
  mounted () {
    this.setDate()
    this.getData()
  },
  computed: mapGetters({
    agent: 'agent'
  })
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
